import { constants } from '..';

const EMPTY_HEADER = {
  status: [],
  referrer_phone: [],
  invitee_phone: [],
  required_spend_eur: [],
  current_spend_eur: [],
  remaining_eur: [],
};

const INITIAL_STATE = {
  loading: false,
  total: 0,
  header: { ...EMPTY_HEADER },
  affiliateInvites: [],

  settings: null,
  settingsLoading: false,
  settingsSaving: false,
};

export const affiliateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.affiliate.SET_AFFILIATE_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.affiliate.SET_AFFILIATE_INVITES:
      return {
        ...state,
        affiliateInvites: action.affiliateInvites,
        header: { ...EMPTY_HEADER, ...action.header },
        total: action.count,
      };
    case constants.affiliate.CLEAR_AFFILIATE_INVITES:
      return {
        ...state,
        loading: false,
        total: 0,
        header: { ...EMPTY_HEADER },
        affiliateInvites: [],
      };
    case constants.affiliate.SET_AFFILIATE_SETTINGS_LOADING:
      return {
        ...state,
        settingsLoading: action.flag,
      };
    case constants.affiliate.SET_AFFILIATE_SETTINGS_SAVING:
      return {
        ...state,
        settingsSaving: action.flag,
      };
    case constants.affiliate.SET_AFFILIATE_SETTINGS:
      return {
        ...state,
        settings: action.settings,
      };
    default:
      return state;
  }
};
